import dayjsTZ from "../../../../../utils/dayjs";

/**
 * Build end instant on the clock-in calendar day with the picker's H:M.
 * @param {number} clockInMs
 * @param {import('dayjs').Dayjs|number|string|Date} endHm
 */
export function sameDayEndFromHm(clockInMs, endHm) {
  if (clockInMs == null || endHm == null) return null;
  const start = dayjsTZ(clockInMs);
  const hm = dayjsTZ(endHm);
  return start
    .hour(hm.hour())
    .minute(hm.minute())
    .second(hm.second?.() ?? 0)
    .millisecond(0);
}

/**
 * Para mesnatës: end must be strictly after clock-in on the same calendar day
 * (H:M cannot wrap past midnight onto an earlier wall time).
 *
 * @param {number} clockInMs
 * @param {import('dayjs').Dayjs|number|string|Date|null|undefined} endHm
 */
export function isValidSameDayEnd(clockInMs, endHm) {
  if (clockInMs == null || endHm == null) return false;
  const end = sameDayEndFromHm(clockInMs, endHm);
  if (!end || !end.isValid()) return false;
  const start = dayjsTZ(clockInMs);
  if (end.format("YYYY-MM-DD") !== start.format("YYYY-MM-DD")) return false;
  return end.valueOf() > start.valueOf();
}

/**
 * Default end time for para mesnatës: only seed when "now" is still the same
 * calendar day as clock-in and after start; otherwise null (user must pick).
 *
 * @param {number} clockInMs
 * @param {import('dayjs').Dayjs|number} [now]
 */
export function suggestSameDayEnd(clockInMs, now = dayjsTZ()) {
  if (clockInMs == null) return null;
  const start = dayjsTZ(clockInMs);
  const nowDj = dayjsTZ(now);
  if (nowDj.format("YYYY-MM-DD") !== start.format("YYYY-MM-DD")) {
    return null;
  }
  if (!isValidSameDayEnd(clockInMs, nowDj)) {
    return null;
  }
  return sameDayEndFromHm(clockInMs, nowDj);
}

/** Hours before clock-in hour (0 .. hour-1) — same-day semantics. */
export function sameDayDisabledHours(clockInMs) {
  const h = dayjsTZ(clockInMs).hour();
  const hours = [];
  for (let i = 0; i < h; i++) hours.push(i);
  return hours;
}

/** Minutes before clock-in (+5m slack) when picking the start hour. */
export function sameDayDisabledMinutes(clockInMs, hour) {
  const start = dayjsTZ(clockInMs);
  if (hour !== start.hour()) return [];
  const minutes = [];
  for (let i = 0; i < start.minute() + 5; i++) {
    minutes.push(i);
  }
  return minutes;
}
